import { AxiosError } from 'axios'

import { httpClient } from '@/services/http/httpClient'

type TermResponse = {
  id: string
  value: string
}

export type Term = {
  id: string
  terms: string
}

export async function getTermsOfUse(): Promise<Term> {
  try {
    const { data } = await httpClient.get<TermResponse>(
      '/tennants/configs/company-terms',
    )

    return {
      id: data.id,
      terms: data.value,
    }
  } catch (error) {
    if (error instanceof AxiosError && error.response?.status === 404) {
      return { id: '', terms: '' }
    }

    throw error
  }
}
